import PropTypes from 'prop-types'
import React from 'react'
import { findDOMNode } from 'react-dom'

/*
 React removes custom attributes from DOM and current design depend on am-grid-col and amd-grid-row attributes.
 The only way to add those is to do it directly on DOM after component mounted. That's why we need this component.
 It allows to set AmGrid custom attributes.
 */
class AmGrid extends React.Component {
  static propTypes = {
    'am-grid': PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string
    ]),
    'am-grid-col': PropTypes.string,
    'am-grid-row': PropTypes.string
  }

  componentDidMount () {
    const dom = findDOMNode(this)

    Object.keys(AmGrid.propTypes).forEach((attributeName) => {
      if (typeof this.props[attributeName] !== 'undefined') {
        dom.setAttribute(attributeName, this.props[attributeName])
      }
    })
  }

  render () {
    return (
      <div className={this.props.className}>
        {this.props.children}
      </div>
    )
  }
}

export default AmGrid



// WEBPACK FOOTER //
// ./client/components/amGrid.js